// extracted by mini-css-extract-plugin
module.exports = {"title":"Admissions-module__title___sgz9H Fonts-module__h4___38fDC","admission":"Admissions-module__admission___1VD94"};